export default ({ titleId, title, href, ariaLabel }) => `<h2 title="${ title }" class="title-name" data-media-id="${ titleId }" tabindex="-1">
    <a tabindex="0" href="${ href }" role="link" aria-label="${ ariaLabel }">
        ${ title }
    </a>
</h3>`;
